import { ValuationResponse } from "../api/endpoints/valuation/types"
import { VehicleDetailsResponse } from "../api/endpoints/vehicleDetails/types"

export type AppState = {
  registration: string
  contactDetails: {
    firstName: string
    lastName: string
    email: string
    countryCode: string
    contactNumber: string
    postcode: string
  }
  appointmentDetails: {
    postCode: string
    dealership: string
  }
  closestDealerships: any[]
  dealershipGuid: string
  dealershipUrl: string
  vehicleDetails: VehicleDetailsResponse
  vehicleCondition: string
  mileage: string
  whichVehicleType: string
  whichVehicle: {
    model: string
    brand: string
  }
  auth: object
  valuation: ValuationResponse.RootObject
  termsConditions: boolean
  bookingStatus: {
    status: number,
    message: string
  }
  bookingDate: string
  bookingTime: string
  lead: object
  limitReached: boolean
  groupId: number
  stockAuth: object
  existsInStock: boolean | undefined
}

export type Action = {
  type:
    | "ADD_REG"
    | "ADD_VEHICLE_DETAILS"
    | "ADD_VEHICLE_CONDITION"
    | "ADD_CONTACT_DETAILS"
    | "ADD_APPOINTMENT_DETAILS"
    | "ADD_MILEAGE"
    | "ADD_WHICH_VEHICLE"
    | "ADD_WHICH_VEHICLE_TYPE"
    | "ADD_AUTH"
    | "ADD_VALUATION"
    | "ADD_TERMS_CONDITIONS"
    | "ADD_BOOKING_STATUS"
    | "ADD_BOOKING_DATE"
    | "ADD_BOOKING_TIME"
    | "ADD_LEAD"
    | "ADD_GROUP_ID"
    | "ADD_DEALERSHIP_GUID"
    | "ADD_CLOSEST_DEALERSHIPS"
    | "ADD_DEALERSHIP_URL"
    | "ADD_LIMIT_REACHED"
    | "ADD_STOCK_AUTH"
    | "ADD_EXISTS_IN_STOCK"
    | "RESET_STATE"
  data: any
}

export type Actions = {
  addReg: Function
  addVehicleDetails: Function
  addVehicleCondition: Function
  addContactDetails: Function
  addAppointmentDetails: Function
  addMileage: Function
  addWhichVehicle: Function
  addWhichVehicleType: Function
  addAuth: Function
  addValuation: Function
  addValuationLimit: Function
  addTermsConditions: Function
  addBookingStatus: Function
  addBookingDate: Function
  addBookingTime: Function
  addLead: Function
  addGroupId: Function
  addDealershipGuid: Function
  addClosestDealerships: Function
  addDealershipUrl: Function
  addStockAuth: Function
  addExistsInStock: Function
  resetState: Function
}

export const initialState: AppState = {
  registration: "",
  contactDetails: {
    firstName: "",
    lastName: "",
    email: "",
    countryCode: "+44",
    contactNumber: "",
    postcode: "",
  },
  appointmentDetails: {
    postCode: "",
    dealership: "",
  },
  closestDealerships: [],
  dealershipGuid: "",
  dealershipUrl: "",
  vehicleDetails: {} as VehicleDetailsResponse,
  vehicleCondition: "",
  mileage: "",
  whichVehicleType: "",
  whichVehicle: {
    model: "",
    brand: "",
  },
  auth: {},
  valuation: {} as ValuationResponse.RootObject,
  termsConditions: false,
  bookingStatus: {
    status: 0,
    message: ""
  },
  bookingDate: "",
  bookingTime: "",
  lead: {},
  limitReached: false,
  groupId: 0,
  stockAuth: {},
  existsInStock: undefined,
}

export const reducer = (state: AppState, action: Action): AppState => {
  switch (action.type) {
    case "ADD_REG":
      return { ...state, registration: action.data.toUpperCase() }
    case "ADD_VEHICLE_DETAILS":
      return { ...state, vehicleDetails: action.data }
    case "ADD_VEHICLE_CONDITION":
      return { ...state, vehicleCondition: action.data }
    case "ADD_AUTH":
      return { ...state, auth: action.data }
    case "ADD_CONTACT_DETAILS":
      return {
        ...state,
        contactDetails: {
          firstName: action.data.firstName,
          lastName: action.data.lastName,
          email: action.data.email,
          countryCode: action.data.countryCode,
          contactNumber: action.data.contactNumber,
          postcode: action.data.postcode,
        },
      }
    case "ADD_APPOINTMENT_DETAILS":
      return {
        ...state,
        appointmentDetails: {
          postCode: action.data.postCode,
          dealership: action.data.dealership,
        },
      }
    case "ADD_CLOSEST_DEALERSHIPS":
      return { ...state, closestDealerships: action.data.data }
    case "ADD_MILEAGE":
      return { ...state, mileage: action.data }
    case "ADD_WHICH_VEHICLE_TYPE":
      return { ...state, whichVehicleType: action.data }
    case "ADD_WHICH_VEHICLE":
      return {
        ...state,
        whichVehicle: {
          model: action.data.model,
          brand: action.data.brand,
        },
      }
    case "ADD_VALUATION":
      return {
        ...state,
        valuation: action.data,
      }
    case "ADD_TERMS_CONDITIONS":
      return {
        ...state,
        termsConditions: action.data,
      }
    case "ADD_BOOKING_STATUS":
      return {
        ...state,
        bookingStatus: action.data,
      }
    case "ADD_BOOKING_DATE":
      return {
        ...state,
        bookingDate: action.data,
      }
    case "ADD_BOOKING_TIME":
      return {
        ...state,
        bookingTime: action.data,
      }
    case "ADD_LEAD":
      return {
        ...state,
        lead: action.data,
      }
    case "ADD_DEALERSHIP_GUID":
      return {
        ...state,
        dealershipGuid: action.data,
      }
    case "ADD_DEALERSHIP_URL":
      return {
        ...state,
        dealershipUrl: action.data,
      }
    case "ADD_LIMIT_REACHED":
      return {
        ...state,
        limitReached: action.data,
      }
    case "ADD_GROUP_ID":
      return {
        ...state,
        groupId: action.data,
      }
    case "ADD_STOCK_AUTH":
      return { ...state, stockAuth: action.data }
    case "ADD_EXISTS_IN_STOCK":
      return {
        ...state,
        existsInStock: action.data,
    }
    case "RESET_STATE": 
        return initialState;
    default:
      throw new Error()
  }
}
